import { StyledContainer } from "./Container.styled";

export const Container = ({ children }) => (
  <StyledContainer>{children}</StyledContainer>
);
